/**
 * У некоторых пользователей опыт работы указан не "с ХХХХ года", а в формате "Более N лет".
 * Пока эта проблема системно не решена.
 * Для пользователей с таким форматом опыта работы не добавляем в текст "с" и "года".
 * @param experience опыт агента
 */
export function prepareAgentExperience(experience?: string | null) {
  if (!experience) {
    return undefined;
  }

  if (experienceInWrongFormat(experience)) {
    return `более ${clearExperience(experience)} лет`;
  }

  return experience;
}

function clearExperience(experience: string) {
  return experience.replace(/\D+/g, '');
}

function experienceInWrongFormat(experience: string) {
  return experience.toLowerCase().includes('более');
}
